<template>
  <div>
    <MasterDetail
      ref="masterDetail"
      formTitle="Cadastro de Projetos ICT"
      :cols="cols"
      :opts="opts"
      :customResource="customResource"
      descriptionProperty="nome_projeto"
      serverPagination
      :canEdit="false"
      :canDelete="true"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      :hasNewButton="false"
      :contextOptions="contextOptions"
      :actionBarButtons="actionBarButtons"
      :confirmDeleteMessage="confirmDeleteMessage"
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="table-v-action-button mr-3" v-bind="attrs" v-on="on">
            <v-icon>mdi-file-delimited-outline</v-icon>
            Exportações
          </div>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="table-v-action-button" @click="exportCsv()">
              <v-icon>mdi-file-delimited</v-icon>
              XLSX Assíncrono
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </MasterDetail>
    <v-dialog v-model="exportacaoAsyncDialog" scrollable persistent max-width="400">
      <v-card>
        <v-card-title style="display: block" class="pb-1">
          <v-icon x-large class="mr-3">mdi-file-delimited-outline</v-icon>
          Exportar Relatório
          <v-btn @click="exportacaoAsyncDialog = false" style="position: absolute; right: 5px; top: 5px" icon>
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Requisição entrou na fila para processamento.</p>
          <p>Para ver o progresso e baixar o relatório, veja a fila.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6 pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="pr-5" dark depressed @click="exportacaoAsyncDialog = false">
            <v-icon left>mdi-chevron-left</v-icon> Fechar
          </v-btn>
          <v-btn color="primary" dark depressed class="px-5 ml-3" @click="verFila()">
            Ver fila
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import ictProjetosService from "@/api/ict/ictProjetos.service";
import ictClientesService from "@/api/ict/ictClientes.service";

export default {
  name: "IctProjetos",
  components: {
    MasterDetail,
  },
  computed: {
    empresaId() {
      return this.$store.getters.clientId;
    },
    customResource() {
      const empresaId = this.empresaId;
      return {
        get: (params) => ictProjetosService.getAll(empresaId, params),
        save: (data, id) =>
          id
            ? ictProjetosService.update(empresaId, id, data)
            : ictProjetosService.create(empresaId, data),
        delete: (id) => ictProjetosService.delete(empresaId, id),
      };
    },
    actionBarButtons() {
      return [
        {
          text: "Adicionar",
          icon: "mdi-plus",
          action: () => {
            this.$router.push({ name: "ict-projetos-cadastro" });
          },
        },
      ];
    },
    contextOptions() {
      return [
        {
          name: "Editar",
          show: this.userHasAccess("ICT.projetos.update"),
          cb: (row) => {
            this.$router.push({
              name: "ict-projetos-edicao",
              params: { id: row.id },
            });
          },
        },
        {
          name: "Baixar todos os anexos",
          show: (row) =>
            this.userHasAccess("ICT.projetos.update") &&
            !!row.anexos_count &&
            row.anexos_count > 0,
          cb: (row) => {
            ictProjetosService.downloadAll(this.empresaId, row.id);
          },
        },

      ];
    },
  },
  data() {
    return {
      exportacaoAsyncDialog: false,
      cols: [
        {
          key: "id",
          name: "ID",
          hideInform: true,
          filterable: true,
        },
        {
          key: "nome_projeto",
          name: "Nome do Projeto",
          type: this.$fieldTypes.TEXT,
          colSize: 12,
          filterable: true,
        },
        {
          key: "sigla_projeto",
          name: "Sigla",
          type: this.$fieldTypes.TEXT,
          colSize: 6,
          filterable: true,
        },
        {
          key: "cliente_id",
          name: "Instituição",
          type: this.$fieldTypes.SELECT,
          colSize: 12,
          filterable: true,
          rel: {
            key: "id",
            name: "razao_social",
            to: "clientes",
          },
        },
        {
          key: "ano_base",
          name: "Ano-Base",
          type: this.$fieldTypes.TEXT,
          colSize: 6,
          filterable: true,
        },
        {
          key: "status",
          name: "Status",
          type: this.$fieldTypes.TEXT,
          colSize: 6,
          filterable: true,
          rel: { to: "status", key: "id", name: "name" },
        },
        {
          key: "resp_nome",
          name: "Responsável",
          type: this.$fieldTypes.TEXT,
          colSize: 6,
          hideInform: true,
          filterable: true,
        },
        {
          key: "vigencia_total_inicio",
          name: "Data Inicial",
          type: this.$fieldTypes.DATE,
          colSize: 6,
          hideInform: true,
          filterable: true,
        },
        {
          key: "vigencia_total_fim",
          name: "Data Final",
          type: this.$fieldTypes.DATE,
          colSize: 6,
          hideInform: true,
          filterable: true,
        },
        {
          key: "criado_em",
          name: "Criado Em",
          type: this.$fieldTypes.DATETIME,
          hideInform: true,
          filterable: true,
        },
      ],
      opts: {
        clientes: [],
        status: [
          { id: "Em elaboração do Descritivo", name: "Em elaboração do Descritivo" },
          { id: "Ativo",      name: "Ativo" },
          { id: "Finalizado", name: "Finalizado" },
        ],
      },
    };
  },
  async created() {
    try {
      const response = await ictClientesService.getAll(this.empresaId);
      this.opts.clientes = response.data || response || [];
    } catch (e) {
      console.error("Erro ao carregar clientes", e);
    }
  },
  methods: {
    exportCsv: function () {
      const md = this.$children.find(c => c.$options.name === 'MasterDetail');
      const filters = md ? md.pageTableFilters : {};

      this.apiResource(`v1/clientes/${this.empresaId}/exportacao`)
        .save({
          tipoRelatorio: "ict-projetos",
          filters: JSON.stringify(filters)
        })
        .then(() => {
          this.exportacaoAsyncDialog = true;
        });
    },
    verFila: function () {
      this.$router.push({
        path: "/clientes/dashboard/relatorios-exportados",
      });
    },
    confirmDeleteMessage(row) {
      return `Deseja excluir o projeto "${row.nome_projeto}" para o Ano Base "${row.ano_base}"?`;
    },
  },
};
</script>
